import { render, staticRenderFns } from "./AddToList.vue?vue&type=template&id=4a6fc67d&scoped=true"
import script from "./AddToList.vue?vue&type=script&lang=js"
export * from "./AddToList.vue?vue&type=script&lang=js"
import style0 from "./AddToList.vue?vue&type=style&index=0&id=4a6fc67d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6fc67d",
  null
  
)

export default component.exports